/** "eav" module backend validators ("checkers") unique keys */
export enum EavCheckersEnum {
  /** Check wheter EAV attribute(s) with this ID(s) are exist */
  EAV_ATTRIBUTE_ASSERT_EXISTS_BY_ID = 'eav/eav-attribute-assert-exists-by-id',
  /** Check wheter EAV attribute(s) with ID(s) from this DTO(s) are exist */
  EAV_ATTRIBUTE_ASSERT_EXISTS_BY_DTO = 'eav/eav-attribute-assert-exists-by-dto',
  /** Check wheter EAV attribute(s) with ID(s) extracted from this object's keys are exist */
  EAV_ATTRIBUTE_ASSERT_EXISTS_BY_KEYS = 'eav/eav-attribute-assert-exists-by-keys',
  /** Check wheter EAV entit(y/ies) with this ID(s) are exist */
  EAV_ENTITY_ASSERT_EXISTS_BY_ID = 'eav/eav-entity-assert-exists-by-id',
  /** Check wheter EAV entit(y/ies) with ID(s) from this DTO(s) are exist */
  EAV_ENTITY_ASSERT_EXISTS_BY_DTO = 'eav/eav-entity-assert-exists-by-dto',
  /** Check wheter EAV entity type(s) with this ID(s) are exist */
  EAV_ENTITY_TYPE_ASSERT_EXISTS_BY_ID = 'eav/eav-entity-type-assert-exists-by-id',
  /** Check wheter EAV entity type(s) with ID(s) from this DTO(s) are exist */
  EAV_ENTITY_TYPE_ASSERT_EXISTS_BY_DTO = 'eav/eav-entity-type-assert-exists-by-dto',
}
